module.exports = __webpack_public_path__ + "static/media/github.2fecdfe3.png";